/**
 * Stretched Clusters constants.
 *
 * Stretched Clusters are Host Aggregates tagged with special metadata to identify
 * them as part of a stretched cluster HA pair. Each cluster can have exactly
 * two stretched clusters (A and B), with hosts divided between them.
 *
 * @see stretched-clusters.spec.md for full specification
 */

/** Metadata key on Host Aggregate that marks it as a stretched cluster */
export const STRETCHED_CLUSTER_METADATA_KEY = 'pf9_failure_domain'
/** Metadata key storing the domain label ('A' or 'B') */
export const STRETCHED_CLUSTER_LABEL_KEY = 'pf9_fd_label'

/** Metadata value indicating an aggregate is a stretched cluster */
export const STRETCHED_CLUSTER_METADATA_VALUE = 'true'

/** Which side of the stretched cluster pair a domain belongs to */
export enum StretchedClusterLabel {
  A = 'A',
  B = 'B',
}

/** Health status derived from host online/offline counts within a domain */
export enum StretchedClusterStatus {
  Healthy = 'Healthy',
  Warning = 'Warning',
  Offline = 'Offline',
}

export const DELETE_WARNINGS = [
  'The cluster reverts to a normal cluster (both peer domains are removed; you cannot delete only one stretched cluster).',
  'VMs lose domain-based recovery. VM HA reverts to normal cluster-wide recovery.',
  'DRR returns to rebalancing cluster-wide.',
  'Hosts are no longer bound to a stretched cluster.',
  'Host aggregates become allowed on the cluster again.',
]
